module.exports = __webpack_public_path__ + "img/sign_project_model.31a2fa5f.png";